module.exports = __webpack_public_path__ + "static/img/visa-icon.8583a108.png";